import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import app from 'new-ui/app';
import { getLocalStorageUser } from 'functions/getLocalStorageUser';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';
import { REDIRECT_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { useIsPreliminaryAuth } from 'utils/hooks/useIsPreliminaryAuth';
import { useAuth } from 'utils/hooks/useAuth';

const PrivateRoute = ({ component: Component, redirect, ...rest }) => {
  const loggedIn = useIsPreliminaryAuth();
  const { isAuthPending } = useAuth();

  const { location } = window;

  const params = new URLSearchParams(window.location.search);
  if (redirect) {
    window.location = `${redirect}?${params.toString()}`;
    return null;
  }
  if (!loggedIn && !getLocalStorageUser()) {
    if (location.pathname.startsWith('/dashboard/trial/')) {
      window.location = `/trial/${location.pathname.split('/dashboard/trial/')[1]}`;
      return null;
    }
    localStorage.clear();
    params.append(REDIRECT_URL_SEARCH_PARAM, location.pathname);

    window.location = `${ROUTE_PATH[ROUTE_NAME.LOGIN]}?${params.toString()}`;
    return null;
  }
  if (isAuthPending && !app.isCurrentPage(ROUTE_NAME.CHAT)) {
    return null;
  }
  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  redirect: PropTypes.string,
};

export default withRouter(PrivateRoute);
